import { FieldComponent, FieldProps } from 'field-rat-core';
import React, { Component } from 'react';
import SortAllProductsFormsField from './SortAllProductsFormsField';

/**
 * This is a "field-rat" interfaced field for backward compatability
 */
type Props = FieldProps<Value>;
interface State { }
type Value = number[];
export default class SortAllProductsFieldRatField extends Component<Props, State>
    implements FieldComponent<Value, {}, State> {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    public state = {
        value: this.props.initialValue,
    };

    public async getValue() {
        return this.state.value;
    }

    public handleChange = (newValue: number[]) => {
        this.setState({ value: newValue });
    }

    public render() {
        return <SortAllProductsFormsField value={this.state.value} onValueChange={this.handleChange} />
    }
}
